import { db } from '../firebase/config';
import { collection, getDocs, updateDoc, doc, writeBatch } from 'firebase/firestore';

const USERS_COLLECTION = 'users';

export const activateAllUsers = async () => {
    try {
        console.log('Tüm kullanıcıları aktifleştirme işlemi başlatılıyor...');
        
        // Tüm kullanıcıları getir
        const usersRef = collection(db, USERS_COLLECTION);
        const querySnapshot = await getDocs(usersRef);
        
        // Batch işlemi başlat
        const batch = writeBatch(db);
        let updateCount = 0;

        querySnapshot.forEach((userDoc) => {
            const userData = userDoc.data();
            // Sadece isActive alanı false olan veya hiç olmayan kullanıcıları güncelle
            if (!userData.isActive) {
                batch.update(userDoc.ref, {
                    isActive: true,
                    updatedAt: new Date()
                });
                updateCount++;
            }
        });

        if (updateCount > 0) {
            // Batch işlemini uygula
            await batch.commit();
            console.log(`${updateCount} kullanıcı başarıyla aktifleştirildi.`);
        } else {
            console.log('Tüm kullanıcılar zaten aktif.');
        }

        return updateCount;
    } catch (error) {
        console.error('Kullanıcıları aktifleştirme hatası:', error);
        throw error;
    }
}; 